<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 16 16"
  >
    <g fill="none" fill-rule="evenodd">
      <g fill="#0074FF">
        <g>
          <g>
            <g>
              <g>
                <path
                  d="M15.5 12c.276 0 .5.224.5.5 0 .245-.177.45-.41.492L15.5 13h-8c-.276 0-.5-.224-.5-.5 0-.245.177-.45.41-.492L7.5 12h8zM4.354 2.646c.173.174.192.443.057.638l-.057.07L1.707 6H15.5c.276 0 .5.224.5.5 0 .245-.177.45-.41.492L15.5 7H1.707l2.647 2.646c.173.174.192.443.057.638l-.057.07c-.174.173-.443.192-.638.057l-.07-.057-3.5-3.5-.011-.013C.123 6.83.112 6.816.102 6.802l.044.052c-.026-.027-.05-.056-.069-.087l-.02-.035-.02-.041-.014-.04c-.005-.015-.009-.03-.012-.046l-.006-.03C.002 6.552.001 6.531 0 6.511V6.49c0-.022.002-.043.005-.064L0 6.5c0-.036.004-.071.011-.105l.012-.046.015-.04c.005-.014.012-.027.019-.04.006-.013.013-.025.02-.036l.012-.017.013-.018c.01-.014.02-.027.033-.04l.011-.012 3.5-3.5c.196-.195.512-.195.708 0zM15.5 0c.276 0 .5.224.5.5 0 .245-.177.45-.41.492L15.5 1h-8C7.224 1 7 .776 7 .5c0-.245.177-.45.41-.492L7.5 0h8z"
                  transform="translate(-1396 -24) translate(1308 16) translate(80) translate(8 8) translate(0 1)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
import VueTypes from 'vue-types';
export default {
  name: 'SlideLeftIcon',
  props: {
    height: VueTypes.string.def('16'),
    width: VueTypes.string.def('16'),
  },
};
</script>

<style lang="scss"></style>
